import { Component, OnInit } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { format } from 'date-fns';
import { BtnConfig, DialogService } from 'icc-common-lib';
import { getEndDate, getStartDate } from '../../../shared/utils/time';
import { URLS } from '../../../shared/constant/interface';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.less'],
})
export class TikTokCommentComponent implements OnInit {
  constructor(
    private http: _HttpClient,
    private dialogService: DialogService
  ) {}

  // 自定义组件名
  static NAME = 'icc-msg-comment-comment';

  /** 评论列表 */
  // commentList: Data[] = [];
  commentList: any[] = [];
  /** 评论的按钮配置 */
  commentConfig: BtnConfig[] = [
    {
      icon: './assets/images/btnIcon/comment/top.png',
      tooltipTitle: '点击置顶',
      activeTooltipTitle: '取消置顶',
      active: (item) => item.top,
      click: (item, itemConfig) => {
        this.comfirm(item); // 确定取消或置顶评论
      },
    },
    {
      icon: './assets/images/btnIcon/comment/reply.png',
      tooltipTitle: '回复',
      // activeTooltipTitle: '取消置顶',
      // active: (item)=>item.top,
      click: (item, itemConfig) => {
        this.isReplyBatch = false;
        this.commentItemNow = item;
        this.isOpenReplyDialog = true;
      },
    },
  ];
  /** 评论回复的按钮配置 */
  replyConfig: BtnConfig[] = [
    {
      icon: './assets/images/btnIcon/comment/reply.png',
      tooltipTitle: '回复',
      // activeTooltipTitle: '取消置顶',
      // active: (item)=>item.remove,
      click: (item, itemConfig) => {
        this.commentItemNow = {};
        this.commentItemNow.id = item.commentItemId;
        this.isOpenReplyDialog = true;
      },
    },
  ];
  /** 标签列表 */
  tagList = [];
  /** 文章卡片 */
  cardList = [];
  /** 当前卡片索引 */
  actCardIndex = 0;
  /** 卡片总页数 */
  cardTotal = 1;
  /** 当前卡片处于第几页 */
  actCardPageIndex = 1;

  /** 当前标签索引 */
  actTagIndex = 0;
  /** 当前标签评论总数 */
  commentTotal = 0;

  /** 群发消息列表是否为空 */
  isCardListEmpty = false;
  /** 评论列表是否为空 */
  isCommentListEmpty = false;

  url = URLS.tiktokCommentMedia.url;
  selectedValue = null;
  channels: any[] = [];

  searchOptions: any = {
    msgType: 7,
    timeRange: [getStartDate(new Date(), 7), getEndDate(new Date(), 0)],
  };
  params1 = { pi: 1, ps: 10, params: null };
  params2 = { pi: 1, ps: 10, params: null };

  /** 回复弹窗控制*/
  isOpenReplyDialog = false;
  replyContent;
  commentItemNow;

  selectedCommentItems: any[] = [];

  isReplyBatch = false;

  commentMediaNow;

  isSyncLoading = false;

  nzSpinning = true;

  ngOnInit() {
    this.getChannel();
  }
  checkChangeHandle(value, item) {
    if (value) {
      // 选中
      this.selectedCommentItems.push(item);
    } else {
      // 语音文本
      this.selectedCommentItems.forEach(function (item1, index, arr) {
        if (item1.id === item.id) {
          arr.splice(index, 1);
        }
      });
    }
  }
  clickHandle(index: number, item: any) {
    this.actCardIndex = index;
    this.commentMediaNow = item;
    this.resetTagList();
    this.resetParams2();
    this.getCommentItem();
  }
  /** 改变标签 */
  changeTag(index: number, item: any) {
    this.actTagIndex = index;
    this.resetParams2();
    this.getCommentItem();
  }

  resetParams2() {
    this.params2 = { pi: 1, ps: 10, params: null };
  }

  getChannel() {
    this.http
      .get(URLS.customerGetChannelInfo.url + '?msgType=7')
      .subscribe((res) => {
        this.channels = res.data;
        // this.selectedValue = res.data[0].appKey;
        this.selectedValue = 0;
        this.getCommentMedia();
      });
  }

  getCommentMedia() {
    this.params1.pi = this.actCardPageIndex;
    this.params1.params = {
      //appId: this.selectedValue,
      appId: this.channels[this.selectedValue].appKey,
      msgType: this.searchOptions.msgType,
      startTime:
        this.searchOptions.timeRange.length >= 1
          ? format(this.searchOptions.timeRange[0], 'yyyy-MM-dd HH:mm:ss')
          : null,
      endTime:
        this.searchOptions.timeRange.length >= 2
          ? format(this.searchOptions.timeRange[1], 'yyyy-MM-dd HH:mm:ss')
          : null,
    };
    this.http.post(this.url, this.params1).subscribe(
      (data) => {
        if (data.status === 0) {
          this.cardTotal =
            Math.floor(data.total / this.params1.ps) +
            (data.total % this.params1.ps > 0 ? 1 : 0);
          if (data.list.length > 0) {
            this.isCardListEmpty = false;
            this.cardList = data.list;
            this.actCardIndex = 0;
            this.commentMediaNow = data.list[0];
            this.resetTagList();
            this.getCommentItem();
          } else {
            this.isCardListEmpty = true;
          }
          // this.dialogService.notification.success('成功', '查询成功');
        } else {
          this.dialogService.notification.error('错误', '查询失败');
        }
        this.nzSpinning = false;
      },
      (err) => {
        this.nzSpinning = false;
        this.dialogService.notification.error('错误', err.errorMsg);
      }
    );
  }

  resetCommentMedia() {
    this.cardList = [];
    this.commentList = [];
    this.tagList = [];
    this.actCardIndex = -1;
    this.actTagIndex = 0;
    this.commentTotal = 0;
    this.actCardPageIndex = 1;
    this.getCommentMedia();
  }

  getCommentItem() {
    this.selectedCommentItems = [];
    this.commentList = [];
    this.commentTotal = 0;
    let commentType = this.tagList[this.actTagIndex].commentType;
    this.params2.params = {
      isTopTag: this.actTagIndex,
      commentType,
      msgType: this.searchOptions.msgType,
      mediaId: this.cardList[this.actCardIndex].id,
      appId: this.cardList[this.actCardIndex].appId,
    };
    this.http
      .post(URLS.tiktokCommentItem.url, this.params2)
      .subscribe((data) => {
        if (data.status === 0) {
          this.commentTotal = data.total;
          if (data.list.length > 0) {
            this.isCommentListEmpty = false;
            this.commentList = data.list;
          } else {
            this.isCommentListEmpty = true;
          }
        } else {
          this.dialogService.notification.error('错误', '查询失败');
        }
      });
  }

  /** 卡片翻页 */
  toggleCardPage(prev: boolean): void {
    // 上一页
    if (prev) {
      this.actCardPageIndex =
        --this.actCardPageIndex <= 0 ? 1 : this.actCardPageIndex--;
    } else {
      this.actCardPageIndex =
        ++this.actCardPageIndex > this.cardTotal
          ? this.cardTotal
          : this.actCardPageIndex++;
    }
    this.getCommentMedia();
  }

  comfirm(item) {
    if (!item.top) {
      // 是否停用所选记录？
      let messages = '目前一个视频只支持置顶一条评论，确定置顶该评论吗？';
      const options = {
        cancel: () => {}, // 取消绑定方法
        confirm: () => {
          this.makeCommentTopOrCancel(item);
        }, // 确定绑定方法
      };
      this.dialogService.modal.confirm('请确认是否置顶!', messages, options);
    } else {
      this.makeCommentTopOrCancel(item);
    }
  }

  /**
   * 置顶获取取消置顶评论
   * @param item
   */
  makeCommentTopOrCancel(item) {
    item.top = !item.top;
    this.http.post(URLS.makeCommentTopOrCancel.url, item).subscribe((res) => {
      let tip;
      if (item.top) {
        tip = '置顶';
      } else {
        tip = '取消置顶';
      }
      if (res.status === 0) {
        this.dialogService.notification.success('成功', tip + '成功');
        this.resetParams2();
        this.getCommentItem(); // 刷新列表
      } else {
        this.dialogService.notification.error('错误', tip + '失败');
      }
    });
  }

  /** 批量回复打开窗口*/
  replyBatchOpenDialog() {
    if (this.selectedCommentItems.length <= 0) {
      this.dialogService.notification.error('请选择要回复的评论', '');
      return;
    }
    this.isReplyBatch = true;
    this.isOpenReplyDialog = true;
  }

  cancelReplyDialog() {
    this.replyContent = '';
    this.isOpenReplyDialog = false;
  }

  ensureReplyDialog() {
    if (!this.replyContent) {
      this.dialogService.notification.error('请输入回复内容', '');
      return;
    }
    if (this.isReplyBatch) {
      this.replyCommentBatch();
    } else {
      this.replyCommentOne();
    }
  }

  /** 回复单条评论*/
  replyCommentOne() {
    this.commentItemNow.replyContent = this.replyContent;
    this.http
      .post(URLS.replyTiktokComment.url, this.commentItemNow)
      .subscribe((res) => {
        if (res.status === 0) {
          this.dialogService.notification.success('回复评论', '成功');
        } else {
          this.dialogService.notification.error('回复评论', res.errorMsg);
        }
        this.isOpenReplyDialog = false;
        this.replyContent = '';
        this.resetParams2();
        this.getCommentItem(); // 刷新列表
      });
  }

  /** 批量回复评论*/
  replyCommentBatch() {
    let requestData = {
      replyContent: this.replyContent,
      commentItemDtos: this.selectedCommentItems,
    };
    this.http
      .post(URLS.replyTiktokCommentBatch.url, requestData)
      .subscribe((res) => {
        if (res.status === 0) {
          this.dialogService.notification.success('批量回复评论', '成功');
        } else {
          this.dialogService.notification.error('批量回复评论', res.errorMsg);
        }
        this.isOpenReplyDialog = false;
        this.replyContent = '';
        this.resetParams2();
        this.getCommentItem(); // 刷新列表
      });
  }

  resetTagList() {
    this.tagList = [
      {
        name: '全部评论',
        num: this.cardList[this.actCardIndex].commentTotalCount,
        commentType: 0,
      },
      {
        name: '置顶评论',
        num: this.cardList[this.actCardIndex].commentTopCount,
        commentType: 4,
      },
      {
        name: '我回复的',
        num: this.cardList[this.actCardIndex].commentMyReplyCount,
        commentType: 5,
      },
    ];
  }

  /** 手动同步数据*/
  pullMediaComment() {
    if (!this.commentMediaNow) {
      return;
    }
    // 正在同步
    if (this.isSyncLoading) {
      return;
    }
    // this.isSyncLoading = true;
    this.http
      .post(URLS.pullMediaCommentFromTiktok.url, this.commentMediaNow)
      .subscribe((res) => {
        if (res.status === 0) {
          this.dialogService.notification.success('数据同步', '成功');
        } else {
          this.dialogService.notification.error('数据同步', res.errorMsg);
        }
        this.cardList[this.actCardIndex] = res.data;
        this.resetTagList();
        this.resetParams2();
        this.getCommentItem(); // 刷新列表
        // this.isSyncLoading = false;
      });
  }

  // 设置开始时间为00:00:00 结束时间为23:59:59
  onOkDate($event?) {
    console.log(`$event`, $event);
    if (this.searchOptions.timeRange[0]) {
      // 设置开始时间为选择日期的 00:00:00
      this.searchOptions.timeRange[0] = new Date(
        new Date(
          new Date(this.searchOptions.timeRange[0]).toLocaleDateString()
        ).getTime()
      );
    }
    if (this.searchOptions.timeRange[1]) {
      // 设置开始时间为选择日期的 23:59:59
      this.searchOptions.timeRange[1] = new Date(
        new Date(
          new Date(this.searchOptions.timeRange[1]).toLocaleDateString()
        ).getTime() +
          24 * 60 * 60 * 1000 -
          1
      );
    }
    // 关闭的时候执行查询
    if ($event === false) {
      this.resetCommentMedia();
    }
  }
}
